import { colorPalette } from '../../../../theme';

export enum ButtonColor {
  Primary = 1,
  Gray,
  Blue,
  Cyan,
  Purple,
  RedBackground,
  LightGreen,
  White,
  DashedOutline, // TODO dash border is not yet implemented
  TransparentBlue,
  TransparentGreen,
  TransparentBlack,
  TransparentWhite,
  TransparentRed,
  TransparentGray,
  TransparentGrayLight,
  Transparent,
}

interface ButtonStyleColorsInterface {
  background: string;
  label: string;
  hover: string;
}

export const buttonStyleColors: { [key in ButtonColor]: ButtonStyleColorsInterface } = {
  [ButtonColor.Primary]: {
    background: colorPalette.primaryColorGreen.primary,
    label: '#fff',
    hover: colorPalette.primaryColorGreen._500,
  },
  [ButtonColor.Gray]: {
    background: colorPalette.gray._200,
    label: colorPalette.dark._900,
    hover: '#DDDDDD',
  },
  [ButtonColor.Blue]: {
    background: colorPalette.primaryColorBlue._75,
    label: colorPalette.dark._900,
    hover: colorPalette.primaryColorBlue._100,
  },
  [ButtonColor.Cyan]: {
    background: '#E0F7FA',
    label: '#00B8D4',
    hover: '#C2ECF1',
  },
  [ButtonColor.Purple]: {
    background: colorPalette.purpleGray._50,
    label: colorPalette.purpleGray._500,
    hover: colorPalette.purpleGray._100,
  },
  [ButtonColor.RedBackground]: {
    background: colorPalette.red._400,
    label: '#fff',
    hover: colorPalette.red._500,
  },
  [ButtonColor.LightGreen]: {
    background: 'rgba(94, 229, 44, 0.15)',
    label: colorPalette.primaryColorGreen._500,
    hover: 'rgba(94, 229, 44, 0.35)',
  },
  [ButtonColor.White]: {
    background: '#fff',
    label: '#464663',
    hover: 'rgba(0, 0, 0, 0.05)',
  },
  [ButtonColor.DashedOutline]: {
    background: 'transparent',
    label: colorPalette.dark._900,
    hover: '#F0EFEF',
  },
  [ButtonColor.TransparentBlue]: {
    background: 'transparent',
    label: '#0053CB',
    hover: 'rgba(94, 129, 244, 0.25)',
  },
  [ButtonColor.TransparentGreen]: {
    background: 'transparent',
    label: colorPalette.primaryColorGreen._500,
    hover: 'rgba(94, 229, 44, 0.35)',
  },
  [ButtonColor.TransparentRed]: {
    background: 'transparent',
    label: colorPalette.red._400,
    hover: colorPalette.red._75,
  },
  [ButtonColor.TransparentBlack]: {
    background: 'transparent',
    label: colorPalette.dark._800,
    hover: colorPalette.gray._200,
  },
  [ButtonColor.TransparentWhite]: {
    background: 'transparent',
    label: '#fff',
    hover: colorPalette.dark._700,
  },
  [ButtonColor.TransparentGray]: {
    background: 'transparent',
    label: colorPalette.purpleGray._500,
    hover: colorPalette.gray._200,
  },
  [ButtonColor.TransparentGrayLight]: {
    background: 'transparent',
    label: colorPalette.purpleGray._300,
    hover: colorPalette.gray._200,
  },
  [ButtonColor.Transparent]: {
    background: 'transparent',
    label: 'unset',
    hover: 'unset',
  },
};
